// extracted by mini-css-extract-plugin
export default {"screenshot":"Screenshot_screenshot__Khu+X","placeholder":"Screenshot_placeholder__7-bDC"};